import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { Globe, Plus } from "lucide-react";
import { PageStatus } from "~/routes/(app)/pages/$pageId/-components/page-status";

export const Route = createFileRoute("/(app)/pages/$pageId")({
  component: RouteComponent,
  loader: async ({ context: { queryClient, trpc }, params: { pageId } }) => {
    const pageOptions = await queryClient.ensureQueryData(
      trpc.pages.getPageCrumbOptions.queryOptions(),
    );

    const crumb = pageOptions.find((p) => p.id === pageId);
    if (!crumb) {
      throw redirect({ to: "/pages" });
    }

    return {
      crumb: {
        label: (
          <>
            <Globe className="h-4" />
            {crumb.url}
            {crumb.status !== "completed" && (
              <div className="ml-1">
                <PageStatus status={crumb.status} />
              </div>
            )}
          </>
        ),
        id: crumb.url,
        options: [
          ...pageOptions.map((p) => ({
            type: "nav",
            label: p.url,
            to: "/pages/$pageId/variants",
            params: { pageId: p.id },
          })),
          {
            type: "action",
            label: (
              <>
                <Plus className="h-4 w-4" /> Add Page
              </>
            ),
            dialog: "add_page",
          },
        ],
      },
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
